import React, { createContext, useContext } from "react";

// Hero mode is permanently locked to "day" (light mode). The legacy day/night toggle
// was removed from the UI; this provider stays in place because several components
// (AddressHero, GuaranteeBadge, etc.) still read `mode` to render against the hero.
const HeroModeContext = createContext({ mode: "day", toggle: () => {}, setMode: () => {} });

export function HeroModeProvider({ children }) {
  const value = { mode: "day", toggle: () => {}, setMode: () => {} };
  return <HeroModeContext.Provider value={value}>{children}</HeroModeContext.Provider>;
}

export function useHeroMode() {
  return useContext(HeroModeContext);
}
